import { Scale } from "@pdfking/math"
import { MM } from "@pdfking/quantity"
import { HorizontalAlign } from "@pdfking/renderer-api"

import { PALETTE } from "#constants"
import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { PictureCover } from "../PictureCover"
import { PocketMonths } from "../PocketMonths"

/** Dash, a pocket calendar: the year on its picture on the front; on the
 * back the year at its head in the primary over its months, four across. */
export const Dash: CalendarDesign = {
  cover: PictureCover({ at: 0.7, size: 0.2 }),
  page: ({ outer, short, year }) => {
    const [head, rest] = Slice.top(outer, Scale(short, 0.085), MM(1))
    return [
      Area.text(head, `${year}`, PALETTE.primary, HorizontalAlign.CENTER),
      ...PocketMonths(rest, year, 4),
    ]
  },
  pages: "year",
}
